import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit — a freestanding coat stand: a walnut pole on a small black
// base, four peg arms near the top, one muted brick-red coat hanging.
const WALNUT = "#7a5a3a";
const BLACK = "#2e2e30";
const COAT = "#a05a40";

export const coatRack = defineModel({
  id: "coat-rack",
  batchId: "modern",
  name: "Coat rack",
  tags: ["modern", "interior", "furniture", "hallway", "storage"],
  summary: "A freestanding walnut coat stand with a hanging coat.",
  tiles: { w: 1, h: 1 },
  footprint: 0.9,
  parts(): Part[] {
    return [
      // base
      { geometry: new THREE.CylinderGeometry(0.18, 0.18, 0.04, 12), color: BLACK, position: [0, 0.02, 0] },
      // pole + top knob
      { geometry: new THREE.CylinderGeometry(0.03, 0.03, 1.66, 8), color: WALNUT, position: [0, 0.87, 0] },
      { geometry: new THREE.SphereGeometry(0.05, 8, 6), color: WALNUT, position: [0, 1.72, 0] },
      // peg arms, tilted slightly upward
      { geometry: new THREE.BoxGeometry(0.26, 0.03, 0.03), color: WALNUT, position: [0.13, 1.58, 0], rotation: [0, 0, 0.35] },
      { geometry: new THREE.BoxGeometry(0.26, 0.03, 0.03), color: WALNUT, position: [-0.13, 1.58, 0], rotation: [0, 0, -0.35] },
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.26), color: WALNUT, position: [0, 1.62, 0.13], rotation: [-0.35, 0, 0] },
      { geometry: new THREE.BoxGeometry(0.03, 0.03, 0.26), color: WALNUT, position: [0, 1.62, -0.13], rotation: [0.35, 0, 0] },
      // hanging coat
      { geometry: new THREE.BoxGeometry(0.3, 0.7, 0.12), color: COAT, position: [0.21, 1.24, 0], rotation: [0, 0, 0.06] },
    ];
  },
  animations: [],
});
